import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../../Constant';
import Popup from '../RegisterScreen/Popup';
import MyProfilesidebar from '../Myprofile/MyProfilesidebar';
const Myprofileedit = (props) => {

    const { addresid } = useParams(); // Extract address_id from URL parameters
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        address: '',
        state: '',
        city: '',
        pinCode: '',
        email: '',
        phone: '',
    });

    const [states, setStates] = useState([]); // Store state options
    const [cities, setCities] = useState([]); // Store city options
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(''); // Error state

    // Fetch address details on component load
    // State for managing popup visibility and message
    const [popupVisible, setPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupType, setPopupType] = useState('success'); // Type can be 'success' or 'error'


    const handleClosePopup = () => {
        setPopupVisible(false);  // Close the popup when clicked
    };


    useEffect(() => {
        const fetchAddressDetails = async () => {
            try {
                const response = await fetch(`${api}edit_address`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ address_id: addresid }),
                });
                const data = await response.json();

                if (data.success === "true") {
                    const { first_name, last_name, address, state, city, pin_code, email_id, phone_number } = data.address;
                    setFormData({
                        firstName: first_name,
                        lastName: last_name,
                        address,
                        state,
                        city,
                        pinCode: pin_code,
                        email: email_id,
                        phone: phone_number,
                    });

                    // Fetch states and cities after loading address data
                    fetchStates();
                    fetchCities(state); // Fetch cities for the given state
                } else {
                    setError(`Failed to fetch address details: ${data.message}`);
                }
            } catch (err) {
                setError(`Error fetching address details: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };

        fetchAddressDetails();
    }, [addresid]);

    // Fetch all states
    const fetchStates = async () => {
        try {
            const response = await fetch(api + 'state_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({}),
            });
            const data = await response.json();
            if (data.success === "true") {
                setStates(data.product); // Assuming 'data.product' is the list of states
            } else {
                console.error('Failed to fetch states:', data.message);
            }
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    // Fetch cities based on selected state
    const fetchCities = async (stateId) => {
        try {
            const response = await fetch(api + 'city_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ state_id: stateId }),
            });

            const data = await response.json();
            if (data.success === "true") {
                setCities(data.product); // Assuming 'data.product' is the list of cities
            } else {
                console.error('Failed to fetch cities:', data.message);
            }
        } catch (error) {
            console.error('Error fetching cities:', error);
        }
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        if (name === 'state') {
            fetchCities(value); // Fetch cities when state changes
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission

        try {
            const response = await fetch(`${api}update_address`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    address_id: addresid, // Address ID to update
                    first_name: formData.firstName, // First Name
                    last_name: formData.lastName, // Last Name
                    address: formData.address, // Address
                    state: formData.state, // State ID (selected state ID)
                    city: formData.city, // City ID (selected city ID)
                    pin_code: formData.pinCode, // Pin Code
                    email_id: formData.email, // Email Address
                    phone_number: formData.phone, // Phone Number
                }),
            });
            const data = await response.json();
            if (data.success === "true") {
                setPopupMessage('Address updated successfully!');
                setPopupType('success');
                setPopupVisible(true);
                setTimeout(() => {
                    navigate('/myprofile');
                }, 1000);
            } else {
                alert(`Failed to update address: ${data.message}`);
            }
        } catch (err) {
            alert(`Error updating address: ${err.message}`);
        }
    };
   

    const cancelbtn =()=>{
        navigate('/myprofile')
    }

    return (
        <div className='myprofile-bg pt-40 pb-40'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-3'>
                        <MyProfilesidebar />
                    </div>
                    <div className='col-lg-9'>
                        <div className='myprofile-overview'>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="add-address-tittle">
                                            <h5>Edit Address</h5>
                                        </div>
                                    </div>
                                </div>
                                <form className="row billing-form" onSubmit={handleSubmit}>
                                    {/* Editable form fields */}
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <label>First Name</label><br />
                                        <input
                                            type="text"
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <label>Last Name</label><br />
                                        <input
                                            type="text"
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-lg-12">
                                        <label>Address</label><br />
                                        <textarea
                                            name="address"
                                            value={formData.address}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <label>State</label><br />
                                        <select
                                            name="state"
                                            value={formData.state}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">Select State</option>
                                            {states.map((state) => (
                                                <option key={state.state_id} value={state.state_id}>
                                                    {state.state_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <label>City</label><br />
                                        <select
                                            name="city"
                                            value={formData.city}
                                            onChange={handleInputChange}
                                            required >
                                            <option value="">Select City</option>
                                            {cities.map((city) => (
                                                <option key={city.city_id} value={city.city_id}>
                                                    {city.city_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <label>Pin Code</label><br />
                                        <input
                                            type="text"
                                            name="pinCode"
                                            value={formData.pinCode}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <label>Email</label><br />
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-sm-6 col-md-6">
                                        <label>Phone</label><br />
                                        <input
                                            type="text"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            maxLength="10"
                                            onKeyPress={(e) => {
                                            const charCode = e.which || e.keyCode;
                                            if (!/[0-9]/.test(String.fromCharCode(charCode)) && charCode !== 8) {
                                            e.preventDefault();
                                            }
                                             }
                                                            }                
                                        />
                                    </div>
                                    <div className="col-lg-12 sub-button">
                                        <button type="submit" className="submit">SUBMIT</button>
                                        <a  className="cancel" onClick={cancelbtn}>CANCEL</a>
                                    </div>
                                </form>
                                {popupVisible && (
                                    <Popup
                                        message={popupMessage}
                                        title="Notice"
                                        type={popupType}
                                        onClose={handleClosePopup}
                                    />
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Myprofileedit